import React, { useState } from "react";
import { Collapse } from "reactstrap";

const AccordianContentLeft = () => {
    const [isCollapseFirst, setIsCollapseFirst] = useState(true);
    const toggleFirst = () => setIsCollapseFirst(!isCollapseFirst);

    const [isCollapseSecond, setIsCollapseSecond] = useState(false);
    const toggleSecond = () => setIsCollapseSecond(!isCollapseSecond);

    const [isCollapseThird, setIsCollapseThird] = useState(false);
    const toggleThird = () => setIsCollapseThird(!isCollapseThird);

    const [isCollapseFourth, setIsCollapseFourth] = useState(false);
    const toggleFourth = () => setIsCollapseFourth(!isCollapseFourth);

    const [isCollapseFifth, setIsCollapseFifth] = useState(false);
    const toggleFifth = () => setIsCollapseFifth(!isCollapseFifth);

    return (
        <React.Fragment>
            <div className="accordion-item mt-4 border-0">
                <h2 className="accordion-header" id="buyingone">
                    <button
                        className="accordion-button"
                        onClick={toggleFirst}
                        type="button"
                    >
                        How do I create an account?
                    </button>
                </h2>
                <Collapse isOpen={isCollapseFirst} id="buying-one">
                    <div className="accordion-body">
                        You can sign up easily by clicking on the "Sign Up" button and filling out the registration form with your details.
                    </div>
                </Collapse>
            </div>

            <div className="accordion-item mt-4 border-0">
                <h2 className="accordion-header" id="buyingtwo">
                    <button
                        className="accordion-button"
                        onClick={toggleSecond}
                        type="button"
                    >
                        How do I post a job?
                    </button>
                </h2>
                <Collapse isOpen={isCollapseSecond} id="buying-two">
                    <div className="accordion-body">
                        After logging in as an employer, navigate to the "Post a Job" section, fill in the job details, and publish your listing.
                    </div>
                </Collapse>
            </div>

            <div className="accordion-item mt-4 border-0">
                <h2 className="accordion-header" id="buyingthree">
                    <button
                        className="accordion-button"
                        onClick={toggleThird}
                        type="button"
                    >
                        Can I apply for multiple jobs at once?
                    </button>
                </h2>
                <Collapse isOpen={isCollapseThird} id="buying-three">
                    <div className="accordion-body">
                        Yes, you can apply to as many jobs as you want. Make sure your profile and resume are updated for better chances.
                    </div>
                </Collapse>
            </div>

            <div className="accordion-item mt-4 border-0">
                <h2 className="accordion-header" id="buyingfour">
                    <button
                        className="accordion-button"
                        onClick={toggleFourth}
                        type="button"
                    >
                        How can I contact support if I face issues?
                    </button>
                </h2>
                <Collapse isOpen={isCollapseFourth} id="buying-four">
                    <div className="accordion-body">
                        You can reach out to our support team anytime through the "Contact Us" page or via the chat support widget on the site.
                    </div>
                </Collapse>
            </div>

            <div className="accordion-item mt-4 border-0">
                <h2 className="accordion-header" id="buyingfive">
                    <button
                        className="accordion-button"
                        onClick={toggleFifth}
                        type="button"
                        style={{ lineHeight: '1.5em' }}
                    >
                        What is the confidentiality policy for candidates and client organizations?
                    </button>
                </h2>
                <Collapse isOpen={isCollapseFifth} id="buying-five">
                    <div className="accordion-body">
                        At <strong>Matrix Executive Search Group</strong>, confidentiality is a cornerstone of our process—for both candidates and client organizations.
                        <br />
                        <br />
                        <strong>For Candidates:</strong>
                        <br />
                        Your personal information, résumé, and job search details are kept strictly confidential. We will never share your information with a company without your explicit permission. You remain in full control over where and when your profile is submitted.
                        <br />
                        <br />
                        <strong>For Client Organizations:</strong>
                        <br />
                        We treat every search with discretion and professionalism. Company names, search details, and hiring strategies are kept fully confidential and only discussed with qualified candidates who are pre-screened and aligned with your needs.
                        <br />
                        <br />
                        We are committed to creating a safe, respectful, and private experience for everyone we work with—because trust is essential to successful recruiting.
                    </div>
                </Collapse>
            </div>
        </React.Fragment>
    );
};

export default AccordianContentLeft;
